import styled from 'styled-components';

export const PatientLoginContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background:
    radial-gradient(
      circle at 15% 20%,
      rgba(110, 185, 160, 0.18),
      transparent 35%
    ),
    radial-gradient(
      circle at 85% 80%,
      rgba(53, 109, 159, 0.14),
      transparent 32%
    ),
    linear-gradient(180deg, #f5fbf8 0%, #edf3fb 100%);
`;

export const PatientLoginCard = styled.div`
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid rgba(24, 90, 66, 0.1);
  box-shadow: 0 20px 60px rgba(18, 62, 51, 0.1);
  overflow: hidden;
`;

export const PatientLoginHeader = styled.div`
  padding: 32px 32px 24px;
  background: linear-gradient(140deg, #155d4b 0%, #1f725f 55%, #356d9f 100%);
  color: #ffffff;
  text-align: center;

  .clinic-name {
    font-size: 0.82rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(240, 255, 248, 0.7);
    margin-bottom: 12px;
  }

  .portal-icon {
    width: 52px;
    height: 52px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.22);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    font-size: 24px;
  }

  h1 {
    font-size: 1.45rem;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin: 0 0 6px;
    color: #f8fff9;
  }

  p {
    font-size: 0.9rem;
    color: rgba(240, 255, 248, 0.78);
    margin: 0;
  }
`;

export const PatientLoginBody = styled.div`
  padding: 28px 32px 32px;

  .ant-form-item-label > label {
    font-weight: 500;
    color: #1e4f3c;
  }

  .ant-input,
  .ant-picker {
    border-radius: 10px;
    border-color: rgba(24, 90, 66, 0.2);
  }

  .ant-input:focus,
  .ant-picker-focused {
    border-color: #1f725f;
    box-shadow: 0 0 0 2px rgba(31, 114, 95, 0.12);
  }

  .submit-btn {
    width: 100%;
    height: 46px;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    background: linear-gradient(120deg, #165e47 0%, #2f5d89 100%);
    border: none;
    margin-top: 4px;
  }

  .hint-text {
    text-align: center;
    margin-top: 14px;
    font-size: 0.82rem;
    color: #7a9e8e;
    line-height: 1.5;
  }
`;
